import { FIGHTER, type FighterState, type MatchRules } from "../sim";

/**
 * Длина перехода между клипами по паре «откуда → куда» (Джон 05.11.2026, 00:06: «переходы между анимациями всё ещё
 * сырые»; консультант: «пять кадров на всё подряд — мало для разворота корпуса и много для серии ударов»). Удар по
 * тебе — почти сразу (попадание видно в тот же миг), удар за ударом — коротко, из удара в стойку — долго и мягко.
 */
export type PoseKind = "idle" | "move" | "strike" | "crouch" | "block" | "reaction" | "air" | "turn" | "special";

const DEFAULT = 6;
const INTO: Partial<Record<PoseKind, number>> = { reaction: 3, turn: 8, air: 4, block: 4 };
const PAIRS: Readonly<Partial<Record<`${PoseKind}>${PoseKind}`, number>>> = {
  "strike>strike": 5,
  "strike>idle": 9,
  "strike>move": 7,
  "strike>crouch": 7,
  "idle>strike": 4,
  "move>strike": 4,
  "crouch>strike": 4,
  "block>strike": 4,
  "air>strike": 4,
  "reaction>strike": 5,
  "idle>move": 6,
  "move>idle": 7,
  "idle>crouch": 6,
  "crouch>idle": 7,
  "block>idle": 6,
  "air>idle": 6,
  "air>move": 6,
  "air>crouch": 5,
  "reaction>idle": 8,
  "turn>idle": 8,
  "turn>move": 7,
  "reaction>reaction": 8,
  "special>idle": 14,
  "idle>special": 14,
};

export function blendFrames(from: PoseKind, to: PoseKind): number {
  return PAIRS[`${from}>${to}`] ?? INTO[to] ?? DEFAULT;
}

/** Какого рода поза бойца сейчас — для таблицы переходов. */
export function poseKind(fighter: FighterState, rules: MatchRules, side: 0 | 1): PoseKind {
  switch (fighter.state) {
    case FIGHTER.idle:
      return "idle";
    case FIGHTER.walkForward:
    case FIGHTER.walkBack:
      return "move";
    case FIGHTER.crouch:
    case FIGHTER.crouchBlock:
      return "crouch";
    case FIGHTER.block:
    case FIGHTER.blockstun:
      return "block";
    case FIGHTER.jump:
      return "air";
    case FIGHTER.turn:
      return "turn";
    case FIGHTER.ability: {
      const ability = rules.kits[side][fighter.ability];
      if (ability?.input.taunt) return "special";
      if (ability?.cancelFrom !== undefined && !ability.hitbox) return "move";
      return "strike";
    }
    case FIGHTER.superAttack:
      return "strike";
    default:
      return "reaction";
  }
}
